import React, { useEffect } from "react";
import { Spinner, makeStyles, Text, tokens, MessageBar, MessageBarBody } from "@fluentui/react-components";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { fetchVacancies } from "./vacancies-slice";
import VacancyItem from "./VacancyItem";

const useStyles = makeStyles({
  vacancyItem: {
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    ":first-child": {
      borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
    },
  },
  text: {
    margin: "0",
  },
});

const Vacancies = ({ uids }) => {
  const styles = useStyles();
  const dispatch: AppDispatch = useDispatch();
  const { vacancies, loading } = useSelector((state: RootState) => state.vacancies);

  useEffect(() => {
    dispatch(fetchVacancies(uids));
  }, [dispatch, uids]);

  return (
    <div>
      {loading ? (
        <Spinner />
      ) : vacancies.length > 0 ? (
        <div>
          {vacancies.map((vacancy, index) => (
            <div key={index} className={styles.vacancyItem}>
              <VacancyItem vacancy={vacancy} />
            </div>
          ))}
        </div>
      ) : (
        <MessageBar intent="info">
          <MessageBarBody>
            <Text as="p" block className={styles.text}>
              No vacancies found for this entity.
            </Text>
          </MessageBarBody>
        </MessageBar>
      )}
    </div>
  );
};

export default Vacancies;
